import { queryKeys } from '@sshop/api-client';

import { api } from '@/shared/lib/apiClient';
import { defineQuery } from '@/shared/lib/queryFactory';

export const categoryTreeQuery = () =>
  defineQuery({
    queryKey: queryKeys.category.tree(),
    queryFn: ({ signal }) => api.categories.tree(signal),
    staleTime: 5 * 60_000,
  });
